import {StringKeyed} from "../../types/GenericTypes";

export type NavigationItems = ReadonlyArray<NavigationItem>;

export interface NavigationItem {
    readonly name: string;
    readonly label: string;
    readonly icon: string;
    readonly state: string;
    readonly stateParams: StringKeyed<any> | null;
    readonly translationId?: string;
}

export function homeNavItem(): NavigationItem {
    return {
        name: "home",
        label: "Home",
        icon: "icon-house",
        state: "home",
        stateParams: null,
        translationId: "navigation.HOME"
    };
}

export function tradingDashboardNavItem(): NavigationItem {
    return {
        name: "trading-dashboard",
        label: "Trading Dashboard",
        icon: "fa fa-tachometer",
        state: "trading-dashboard",
        stateParams: null,
        translationId: "navigation.TRADING_DASHBOARD"
    };
}

export function achievementsNavItem(): NavigationItem {
    return {
        name: "achievements",
        label: "Achievements",
        icon: "icon-trophy2",
        state: "achievements",
        stateParams: null
    };
}

export function strategyBuilderNavItem(): NavigationItem {
    return {
        name: "strategy_builder",
        label: "Strategy Builder",
        icon: "icon-carpenter",
        state: "strategy",
        stateParams: null
    };
}

export function portfolioNavItem(portfolioId: number): NavigationItem {
    return {
        name: "portfolio",
        label: "My Portfolio",
        icon: "icon-briefcase1",
        state: "portfolio",
        stateParams: {
            portfolioId
        },
        translationId: "navigation.PORTFOLIO"
    };
}

export function tradeHistoryNavItem(portfolioId: number) {
    return {
        name: "performance",
        label: "Performance",
        icon: "icon-20",
        state: "performance",
        stateParams: {
            portfolioId
        },
        translationId: "navigation.PERFORMANCE"
    };
}

export function gameTradeHistoryNavItem(portfolioId: number) {
    return {
        name: "history",
        label: "History",
        icon: "icon-20",
        state: "performance",
        stateParams: {
            portfolioId
        },
        translationId: "navigation.HISTORY"
    };
}

export function chartingNavItem(): NavigationItem {
    return {
        name: "charting",
        label: "Charting",
        icon: "icon-bar-chart2",
        state: "charting",
        stateParams: null,
        translationId: "navigation.CHARTING"
    };
}

export function backtestingNavItem(): NavigationItem {
    return {
        name: "backtesting",
        label: "Backtesting",
        icon: "fa icon-76 fa-flip-horizontal",
        state: "backtesting",
        stateParams: null
    };
}

export function ordersNavItem(): NavigationItem {
    return {
        name: "orders",
        label: "Orders",
        icon: "icon-shuffle",
        state: "orders",
        stateParams: null,
        translationId: "navigation.ORDERS"
    };
}

export function adviserNavItem(): NavigationItem {
    return {
        name: "adviser",
        label: "Adviser",
        icon: "icon-head",
        state: "adviser",
        stateParams: null,
        translationId: "navigation.ADVISER"
    };
}

export function clearingDashboardNavItem(): NavigationItem {
    return {
        name: "risk-dashboard",
        label: "Clearing Dashboard",
        icon: "icon-08",
        state: "risk-dashboard",
        stateParams: null
    };
}

export function riskManagerNavItem(): NavigationItem {
    return {
        name: "risk",
        label: "Risk Manager",
        icon: "icon-meter",
        state: "risk",
        stateParams: null
    };
}

export function positionSearchNavItem(): NavigationItem {
    return {
        name: "positions",
        label: "Position Search",
        icon: "icon-search",
        state: "positions",
        stateParams: null,
        translationId: "navigation.POSITION_SEARCH"
    };
}

export function auditLogNavItem(): NavigationItem {
    return {
        name: "audit",
        label: "Audit Log",
        icon: "icon-coin-dollar",
        state: "audit",
        stateParams: null
    };
}

export function adminPanelNavItem(): NavigationItem {
    return {
        name: "admin",
        label: "Administration Panel",
        icon: "icon-settings",
        state: "admin",
        stateParams: null
    };
}

export function supportManagerNavItem(): NavigationItem {
    return {
        name: "support",
        label: "Support Manager",
        icon: "icon-thermometer",
        state: "support",
        stateParams: null
    };
}

export function processManagementNavItem(): NavigationItem {
    return {
        name: "process",
        label: "Process Management",
        icon: "icon-thermometer",
        state: "process",
        stateParams: null
    };
}

export function hedgeHelperNavItem(): NavigationItem {
    return {
        name: "hedgeHelper",
        label: "Hedge Helper",
        icon: "icon-thermometer",
        state: "hedgeHelper",
        stateParams: null
    };
}

export function helpNavItem(): NavigationItem {
    return {
        name: "help",
        label: "Help",
        icon: "icon-question",
        state: "help",
        stateParams: null
    };
}

export function education(): NavigationItem {
    return {
        name: "education",
        label: "Education",
        icon: "icon-28",
        state: "education",
        stateParams: null
    };
}

export function companyInfoNavItem(): NavigationItem {
    return {
        name: "company-info",
        label: "Company Info",
        icon: "icon-info_outline",
        state: "company-info",
        stateParams: null,
        translationId: "navigation.COMPANY_INFO"
    };
}

export function stockScreenerNavItem(): NavigationItem {
    return {
        name: "stock-screener",
        label: "Stock Screener",
        icon: "icon-44",
        state: "stock-screener",
        stateParams: null,
        translationId: "navigation.STOCK_SCREENER"
    };
}
